import { Helmet } from 'react-helmet';
import styles from './iacst-result.module.scss';
import { FAQConfig } from 'staticPages/constants';
import Faqaccordion from 'components/Registration/Faq/Faqaccrodion';
import { useSelector } from 'react-redux';
import PageNotFound from 'components/404';

import { useEffect, useState } from 'react';

const IacstResultHero = () => {
    // --- INLINE STYLE OBJECTS ---
    const styles = {
        section: { width: '100%', padding: '44px 0', background: 'linear-gradient(135deg,#eef6ff 0%, #ffffff 55%, #f6fbff 100%)', position: 'relative', overflow: 'hidden' },
        bgCircle1: { position: 'absolute', width: '520px', height: '520px', borderRadius: '50%', background: 'radial-gradient(circle at 35% 35%, rgba(14,165,233,0.18), rgba(14,165,233,0))', top: '-260px', left: '-260px' },
        bgCircle2: { position: 'absolute', width: '520px', height: '520px', borderRadius: '50%', background: 'radial-gradient(circle at 70% 40%, rgba(79,70,229,0.16), rgba(79,70,229,0))', bottom: '-260px', right: '-260px' },
        wrap: { width: '90%', margin: 'auto', maxWidth: '1100px', boxSizing: 'border-box', position: 'relative' },
        stack: { display: 'flex', gap: '18px', alignItems: 'stretch' },
        heroCard: {
            flex: 1, padding: '28px', position: 'relative', overflow: 'hidden',
            background: 'white',
            backdropFilter: 'blur(10px)', transition: 'transform .25s ease, box-shadow .25s ease, border-color .25s ease',
            backgroundColor: '#fff', border: '1px solid #e7ecf6', borderRadius: '18px', boxShadow: '0 12px 28px rgba(15,23,42,0.06)'
        },
        patternOverlay: {
            position: 'absolute', inset: 0, opacity: 0.10, pointerEvents: 'none',
            backgroundImage: 'radial-gradient(circle at 20% 25%, #1d4ed8 0 2px, transparent 3px), radial-gradient(circle at 70% 35%, #0ea5e9 0 2px, transparent 3px), radial-gradient(circle at 35% 80%, #4f46e5 0 2px, transparent 3px)',
            backgroundSize: '46px 46px'
        },
        chip: {
            display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '10px 14px', borderRadius: '999px',
            border: '1px solid #e7ecf6', background: 'linear-gradient(135deg,#f5f8ff 0%, #ffffff 70%)', fontWeight: 900, color: '#0f172a', fontSize: '14px'
        },
        gradientLine: { width: '6px', borderRadius: '999px', background: 'linear-gradient(180deg,#0ea5e9,#1d4ed8,#4f46e5)' },
        h1: { fontSize: '36px', fontWeight: 900, margin: '0 0 18px 0', lineHeight: 1.1, color: '#0f172a' },
        text: { margin: 0, color: '#334155', lineHeight: 1.9, fontSize: '17px' },
        kicker: {
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginTop: '14px',
            padding: '12px 14px', border: '1px solid #e7ecf6', borderRadius: '16px', background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 70%)'
        },
        kickerBadge: { fontWeight: 900, color: '#1d4ed8', background: '#eef5ff', padding: '8px 12px', borderRadius: '999px', border: '1px solid #d9e6ff' },
        iconboxKicker: {
            width: '42px', height: '42px', flex: '0 0 42px', minWidth: '42px', minHeight: '42px', maxWidth: '42px', maxHeight: '42px',
            borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box',
            border: '1px solid #e7ecf6', background: '#f7fbff'
        },
        miniWrap: { display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '14px' },
        mini: {
            display: 'flex', gap: '10px', alignItems: 'center', padding: '10px 12px', borderRadius: '14px', border: '1px solid #e7ecf6',
            background: '#ffffff', boxShadow: '0 8px 18px rgba(15,23,42,0.05)', transition: 'transform .25s ease, box-shadow .25s ease'
        },
        badge: {
            width: '36px', height: '36px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'linear-gradient(135deg,#0ea5e9,#1d4ed8)', boxShadow: '0 10px 20px rgba(29,78,216,0.18)', flex: '0 0 36px'
        },
        miniTitle: { color: '#0f172a', fontWeight: 900, fontSize: '14.5px', lineHeight: 1.2 },
        sidePanel: {
            flex: '0 0 320px', minWidth: '280px', borderRadius: '18px', padding: '22px', color: '#ffffff',
            background: 'linear-gradient(145deg,#0ea5e9 0%, #1d4ed8 55%, #4f46e5 100%)', position: 'relative', overflow: 'hidden',
            boxShadow: '0 16px 40px rgba(14,165,233,0.18)'
        },
        sideOverlay: { position: 'absolute', width: '260px', height: '260px', borderRadius: '50%', background: 'rgba(255,255,255,0.14)', top: '-140px', right: '-140px' },
        sideIconbox: {
            width: '42px', height: '42px', flex: '0 0 42px', minWidth: '42px', minHeight: '42px', maxWidth: '42px', maxHeight: '42px',
            borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box',
            background: 'rgba(255,255,255,0.18)', border: '1px solid rgba(255,255,255,0.22)'
        },
        sideTitle: { marginTop: '14px', fontSize: '24px', fontWeight: 900, lineHeight: 1.25 }
    };

    return (
        <>
            {/* HOVER AND MEDIA QUERIES (Cannot be converted to inline React styles) */}
            <style>{`
        .iacst-hero-anim:hover { box-shadow: 0 18px 46px rgba(15,23,42,0.10) !important; border-color: #cfe0ff !important; transform: translateY(-2px); }
        .iacst-mini-anim:hover { transform: translateY(-2px); box-shadow: 0 14px 26px rgba(15,23,42,0.09) !important; }
        @media (max-width:900px){ .iacst-stack-mq { flex-direction:column !important; } }
        @media (max-width:600px){
          .iacst-wrap-mq { width: 92% !important; }
          .iacst-text-mq { font-size: 16px !important; line-height: 1.85 !important; }
          .iacst-hero-anim { padding: 20px !important; }
          .iacst-kicker-mq { flex-direction: column; align-items: flex-start !important; gap: 10px !important; }
          .iacst-kicker-child { width: 100%; text-align: left; }
          .iacst-mini-anim { width: 100%; box-sizing: border-box; }
          .iacst-sidepanel-mq { flex: 1 1 auto !important; min-width: 0 !important; width: 100% !important; box-sizing: border-box; padding: 18px !important; }
          .iacst-sidetitle-mq { font-size: 20px !important; line-height: 1.25 !important; }
        }
      `}</style>

            <section style={styles.section}>
                <div style={styles.bgCircle1}></div>
                <div style={styles.bgCircle2}></div>

                <div className="iacst-wrap-mq" style={styles.wrap}>
                    <div className="iacst-stack-mq" style={styles.stack}>

                        {/* LEFT: HERO PANEL */}
                        <div className="iacst-hero-anim" style={styles.heroCard}>
                            <div style={styles.patternOverlay}></div>

                            <div style={{ position: 'relative' }}>
                                <div style={styles.chip}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M7 3H17V21H7V3Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M9.5 7H14.5" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M9.5 11H14.5" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                    Result guide
                                </div>

                                <div style={{ display: 'flex', gap: '14px', marginTop: '16px' }}>
                                    <div style={styles.gradientLine}></div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <h1 style={styles.h1}>iACST Result</h1>
                                        <p className="iacst-text-mq" style={styles.text}>
                                            Aakash Institute conducts the iACST to provide students with direct admission and scholarship benefits based on performance. It ensures a smooth and transparent process for NEET, JEE, and Foundation aspirants.
                                        </p>
                                        <p className="iacst-text-mq" style={{ ...styles.text, marginTop: '12px' }}>
                                            This guide explains how to check iACST results, understand scholarship details, and know the next steps after receiving your result.
                                        </p>
                                    </div>
                                </div>

                                {/* Kicker row */}
                                <div className="iacst-kicker-mq" style={styles.kicker}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 900, color: '#0f172a' }}>
                                        <span style={styles.iconboxKicker}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#1d4ed8" strokeWidth="2" />
                                                <path d="M7 12.5L10.2 15.7L17 9" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                        What you’ll learn inside
                                    </div>
                                    <div className="iacst-kicker-child" style={styles.kickerBadge}>
                                        Results • Scholarship • Next steps
                                    </div>
                                </div>

                                {/* Mini tiles */}
                                <div style={styles.miniWrap}>
                                    <div className="iacst-mini-anim" style={styles.mini}>
                                        <span style={styles.badge}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <circle cx="11" cy="11" r="7" stroke="white" strokeWidth="2" />
                                                <path d="M20 20L17 17" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </span>
                                        <div style={styles.miniTitle}>Check result</div>
                                    </div>

                                    <div className="iacst-mini-anim" style={styles.mini}>
                                        <span style={styles.badge}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z" stroke="white" strokeWidth="2" />
                                                <path d="M9 14.5L8 21L12 19L16 21L15 14.5" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                        <div style={styles.miniTitle}>Understand scholarship</div>
                                    </div>

                                    <div className="iacst-mini-anim" style={styles.mini}>
                                        <span style={styles.badge}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M6 3V21" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M6 4H15L14 8H21L20 12H6V4Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                        <div style={styles.miniTitle}>What to do next</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* RIGHT: SIDE STAT PANEL */}
                        <div className="iacst-sidepanel-mq" style={styles.sidePanel}>
                            <div style={styles.sideOverlay}></div>

                            <div style={{ position: 'relative' }}>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    <span style={styles.sideIconbox}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                            <path d="M13 2L3 14H11L9 22L21 10H13V2Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <div style={{ fontWeight: 900, letterSpacing: '0.08em', opacity: 0.95, fontSize: '12px' }}>FAST & TRANSPARENT</div>
                                </div>

                                <div className="iacst-sidetitle-mq" style={styles.sideTitle}>
                                    Direct admission + scholarship benefits
                                </div>

                                <div style={{ marginTop: '14px', padding: '12px 14px', borderRadius: '14px', background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.20)', lineHeight: 1.8 }}>
                                    For students preparing for NEET, JEE, and Foundation courses.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

const IacstResultImportance = () => {
    const [isSmallMobile, setIsSmallMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallMobile(window.innerWidth <= 600);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // --- INLINE STYLE OBJECTS ---
    const styles = {
        section: { width: '100%', padding: '44px 0', background: '#f9fafc' },
        wrap: { width: isSmallMobile ? '92%' : '90%', margin: 'auto', maxWidth: '1100px', boxSizing: 'border-box' },
        headRow: { display: 'flex', alignItems: isSmallMobile ? 'flex-start' : 'flex-end', justifyContent: 'space-between', gap: '14px', flexWrap: 'wrap', marginBottom: '14px', flexDirection: isSmallMobile ? 'column' : 'row' },
        chip: {
            display: 'inline-flex', alignItems: 'center', gap: '10px',
            padding: isSmallMobile ? '9px 12px' : '10px 14px', borderRadius: '999px',
            border: '1px solid #e7ecf6', background: 'linear-gradient(135deg,#f5f8ff 0%, #ffffff 70%)',
            fontWeight: 900, color: '#0f172a', fontSize: isSmallMobile ? '13px' : '14px'
        },
        title: { margin: '12px 0 0 0', color: '#0f172a', fontWeight: 900, lineHeight: isSmallMobile ? 1.2 : 1.15, fontSize: isSmallMobile ? '24px' : '34px', overflowWrap: 'anywhere', wordBreak: 'break-word' },
        valuePill: {
            display: 'flex', gap: '10px', alignItems: 'center', padding: '10px 12px', borderRadius: '999px',
            border: '1px solid #e7ecf6', background: '#ffffff', boxShadow: '0 10px 22px rgba(15,23,42,0.06)',
            width: isSmallMobile ? '100%' : 'auto', boxSizing: 'border-box'
        },
        iconbox: {
            width: isSmallMobile ? '40px' : '44px', height: isSmallMobile ? '40px' : '44px', flex: isSmallMobile ? '0 0 40px' : '0 0 44px',
            borderRadius: isSmallMobile ? '14px' : '16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxSizing: 'border-box', background: '#eefdf3'
        },
        pathWrap: {
            position: 'relative', overflow: 'hidden', borderRadius: isSmallMobile ? '18px' : '22px', border: '1px solid #e7ecf6',
            padding: isSmallMobile ? '14px' : '18px',
            background: 'radial-gradient(900px 340px at 15% 15%, rgba(14,165,233,0.14), rgba(14,165,233,0) 60%), radial-gradient(820px 320px at 88% 35%, rgba(79,70,229,0.12), rgba(79,70,229,0) 60%), linear-gradient(135deg,#f7fbff 0%, #ffffff 60%, #f9fafc 100%)'
        },
        dotOverlay: {
            position: 'absolute', inset: 0, opacity: 0.12, pointerEvents: 'none',
            backgroundImage: 'radial-gradient(circle at 18% 28%, #1d4ed8 0 2px, transparent 3px), radial-gradient(circle at 66% 40%, #0ea5e9 0 2px, transparent 3px), radial-gradient(circle at 38% 78%, #4f46e5 0 2px, transparent 3px)',
            backgroundSize: '52px 52px'
        },
        grid: { display: 'grid', gap: '16px', position: 'relative' },
        step: {
            position: 'relative', borderRadius: '18px', background: 'rgba(255,255,255,0.88)', backdropFilter: 'blur(8px)',
            border: '1px solid #e7ecf6',
            overflow: 'hidden', padding: isSmallMobile ? '14px 14px 14px 16px' : '16px 16px 16px 18px', minWidth: 0
        },
        accent: { position: 'absolute', left: 0, top: 0, bottom: 0, width: '6px', background: 'linear-gradient(180deg,#0ea5e9,#1d4ed8,#4f46e5)' },
        badge: {
            width: isSmallMobile ? '30px' : '34px', height: isSmallMobile ? '30px' : '34px', borderRadius: '999px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #d9e6ff',
            background: '#eef5ff', color: '#1d4ed8', fontWeight: 900, boxShadow: '0 10px 18px rgba(29,78,216,0.12)',
            flex: isSmallMobile ? '0 0 30px' : '0 0 34px', fontSize: isSmallMobile ? '13px' : '16px'
        },
        icGlow: {
            width: isSmallMobile ? '40px' : '44px', height: isSmallMobile ? '40px' : '44px', borderRadius: isSmallMobile ? '14px' : '16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#0ea5e9,#1d4ed8)',
            boxShadow: '0 14px 24px rgba(29,78,216,0.18)', flex: isSmallMobile ? '0 0 40px' : '0 0 44px'
        },
        textCol: { paddingTop: '2px', minWidth: 0, width: isSmallMobile ? '100%' : 'auto' },
        stepTitle: { fontWeight: 900, color: '#0f172a', fontSize: '16px' },
        stepDesc: { marginTop: '4px', color: '#475569', lineHeight: 1.6, fontSize: '14px' },
        note: {
            borderRadius: '18px', border: '1px dashed #cfe0ff', background: 'linear-gradient(135deg,#ffffff 0%, #f5f8ff 70%)',
            padding: isSmallMobile ? '14px' : '16px 18px', marginTop: '16px', position: 'relative', minWidth: 0
        },
        noteText: { margin: 0, color: '#334155', lineHeight: 1.9, fontSize: isSmallMobile ? '16px' : '17px', overflowWrap: 'anywhere', wordBreak: 'break-word' }
    };

    return (
        <>
            <style>{`
  .iacst-step-anim {
    box-shadow: 0 12px 26px rgba(15,23,42,0.06);
    transform: translateY(0); /* 👈 IMPORTANT */
    transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
    will-change: transform; /* 👈 smoother GPU animation */
  }

  .iacst-step-anim:hover {
    transform: translateY(-6px); /* 👈 increase from 3px to make it visible */
    box-shadow: 0 22px 48px rgba(15,23,42,0.14);
    border-color: #cfe0ff;
  }
`}</style>

            <section style={styles.section}>
                <div style={styles.wrap}>

                    {/* Header row */}
                    <div style={styles.headRow}>
                        <div>
                            <div style={styles.chip}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                    <path d="M12 9V13" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M12 17H12.01" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M10 3H14L22 19H2L10 3Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                </svg>
                                Why it matters
                            </div>
                            <h2 style={styles.title}>Why is the iACST Result So Important?</h2>
                        </div>

                        <div style={styles.valuePill}>
                            <span style={styles.iconbox}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                    <path d="M20 7L10 17L4 11" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 2L13.5 7.5L19 9L13.5 10.5L12 16L10.5 10.5L5 9L10.5 7.5L12 2Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" opacity="0.35" />
                                </svg>
                            </span>
                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Decisions at a glance</div>
                        </div>
                    </div>

                    {/* Path container */}
                    <div style={styles.pathWrap}>
                        <div style={styles.dotOverlay}></div>
                        <div style={styles.grid}>

                            {/* STEP 1 */}
                            <div className="iacst-step-anim" style={styles.step}>
                                <div style={styles.accent}></div>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: isSmallMobile ? 'wrap' : 'nowrap' }}>
                                    <div style={styles.badge}>1</div>
                                    <div style={styles.icGlow}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                            <path d="M7 3H17V21H7V3Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            <path d="M10 12L12 14L15.5 10.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M12 9V9" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div style={styles.textCol}>
                                        <div style={styles.stepTitle}>Whether you are eligible for admission</div>
                                        <div style={styles.stepDesc}>Your result confirms if you can take admission right away.</div>
                                    </div>
                                </div>
                            </div>

                            {/* STEP 2 */}
                            <div className="iacst-step-anim" style={styles.step}>
                                <div style={styles.accent}></div>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: isSmallMobile ? 'wrap' : 'nowrap' }}>
                                    <div style={styles.badge}>2</div>
                                    <div style={{ ...styles.icGlow, background: 'linear-gradient(135deg,#4f46e5,#1d4ed8)' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                            <path d="M20 12L12 20L4 12V4H12L20 12Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            <path d="M8.5 8.5C9.1 8.5 9.5 8.1 9.5 7.5C9.5 6.9 9.1 6.5 8.5 6.5C7.9 6.5 7.5 6.9 7.5 7.5C7.5 8.1 7.9 8.5 8.5 8.5Z" stroke="white" strokeWidth="2" />
                                            <path d="M15.5 15.5C16.1 15.5 16.5 15.1 16.5 14.5C16.5 13.9 16.1 13.5 15.5 13.5C14.9 13.5 14.5 13.9 14.5 14.5C14.5 15.1 14.9 15.5 15.5 15.5Z" stroke="white" strokeWidth="2" />
                                            <path d="M16 8L8 16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div style={styles.textCol}>
                                        <div style={styles.stepTitle}>How much scholarship or fee concession will you get</div>
                                        <div style={styles.stepDesc}>It directly impacts your fee structure and savings.</div>
                                    </div>
                                </div>
                            </div>

                            {/* STEP 3 */}
                            <div className="iacst-step-anim" style={styles.step}>
                                <div style={styles.accent}></div>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: isSmallMobile ? 'wrap' : 'nowrap' }}>
                                    <div style={styles.badge}>3</div>
                                    <div style={{ ...styles.icGlow, background: 'linear-gradient(135deg,#0ea5e9,#22c55e)' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                            <path d="M12 2L22 8L12 14L2 8L12 2Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            <path d="M22 12L12 18L2 12" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            <path d="M22 16L12 22L2 16" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div style={styles.textCol}>
                                        <div style={styles.stepTitle}>Which batch or course level will you be placed in</div>
                                        <div style={styles.stepDesc}>Batch mapping helps you start at the right level.</div>
                                    </div>
                                </div>
                            </div>

                            {/* STEP 4 */}
                            <div className="iacst-step-anim" style={styles.step}>
                                <div style={styles.accent}></div>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: isSmallMobile ? 'wrap' : 'nowrap' }}>
                                    <div style={styles.badge}>4</div>
                                    <div style={{ ...styles.icGlow, background: 'linear-gradient(135deg,#1d4ed8,#0ea5e9)' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                            <path d="M6 22V4" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                            <path d="M6 4H17L15 8L17 12H6" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                            <path d="M6 12H15" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.35" />
                                        </svg>
                                    </div>
                                    <div style={styles.textCol}>
                                        <div style={styles.stepTitle}>Your starting academic position at Aakash</div>
                                        <div style={styles.stepDesc}>Sets your learning plan from day one.</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Bottom note */}
                        <div style={styles.note}>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                <span style={{ ...styles.iconbox, background: '#eef5ff' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M12 10V17" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M12 7H12.01" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
                                    </svg>
                                </span>
                                <p style={styles.noteText}>
                                    That is why every student must clearly know how to check iACST results and understand what it shows.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

const IacstStepGuide = () => {
    return (
        <>
            <style>{`
        /* Shared utilities */
        .iacst-wrap{ width:90%; margin:auto; max-width:1100px; box-sizing:border-box; }
        .iacst-card{ background:#fff; border:1px solid #e7ecf6; border-radius:18px; box-shadow:0 12px 28px rgba(15,23,42,0.06); }
        .iacst-title{ margin:0; color:#0f172a; font-weight:900; line-height:1.15; }
        .iacst-text{ margin:0; color:#334155; line-height:1.9; font-size:17px; }
        .iacst-chip{
          display:inline-flex; align-items:center; gap:10px;
          padding:10px 14px; border-radius:999px;
          border:1px solid #e7ecf6; background:linear-gradient(135deg,#f5f8ff 0%, #ffffff 70%);
          font-weight:900; color:#0f172a; font-size:14px;
        }
        .iacst-hr{ height:1px; background:#e7ecf6; border:none; margin:18px 0; }

        /* ✅ Prevent mobile overflow / random breaks */
        .iacst-wrap *{ box-sizing:border-box; max-width:100%; }
        .iacst-title, .iacst-text{ overflow-wrap:anywhere; word-break:break-word; }

        @media (max-width:900px){
          .iacst-stack{ flex-direction:column !important; }
          .iacst-hide-m{ display:none !important; }
        }

        /* Steps (compact) */
        .iacst-step{ display:flex; gap:14px; padding:14px; border-radius:16px; border:1px solid #e7ecf6; background:#ffffff; transition: all 0.3s ease; }
        .iacst-step > div{ min-width:0; } /* ✅ allows text wrap inside flex */
        .iacst-stepnum{
          width:34px; height:34px; flex:0 0 34px;
          min-width:34px; min-height:34px; max-width:34px; max-height:34px;
          border-radius:50%; background:#002f6c; color:#fff;
          display:flex; align-items:center; justify-content:center; font-weight:900;
          box-sizing:border-box;
          box-shadow:0 0 0 6px rgba(0,47,108,0.08);
        }

        /* ✨ Added Hover Effects for individual cards */
        .iacst-step:hover {
          transform: translateY(-3px) !important;
          box-shadow: 0 10px 20px rgba(15,23,42,0.08) !important;
        }

        /* ✅ micro “chips” for step 2 options (smaller + wraps tight) */
        .iacst-miniopt{
          display:inline-flex;
          align-items:center;
          gap:8px;
          padding:7px 10px;
          border-radius:999px;
          border:1px solid #e7ecf6;
          background:#f7fbff;
          font-weight:800;
          color:#0f172a;
          font-size:13px;
          line-height:1.2;
          white-space:nowrap;
          max-width:100%;
        }
        .iacst-minisvg{
          width:18px; height:18px;
          border-radius:8px;
          background:#eef5ff;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          flex:0 0 18px;
        }

        /* ================================
           RIGHT CARD (UPDATED ONLY)
           ================================ */
        .iacst-rightGlass2{
          position:relative;
          overflow:hidden;
          border-radius:18px;
          padding:18px;
          border:1px solid rgba(231,236,246,0.95);
          background:
            radial-gradient(520px 260px at 15% 10%, rgba(14,165,233,0.18), rgba(14,165,233,0) 60%),
            radial-gradient(520px 260px at 85% 30%, rgba(79,70,229,0.16), rgba(79,70,229,0) 60%),
            linear-gradient(145deg, rgba(255,255,255,0.78) 0%, rgba(245,250,255,0.62) 55%, rgba(255,255,255,0.72) 100%);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          box-shadow: 0 18px 50px rgba(15,23,42,0.10);
          color:#0f172a;
        }
        .iacst-rightGlass2:before{
          content:"";
          position:absolute; inset:0;
          pointer-events:none;
          opacity:0.55;
          background:
            radial-gradient(circle at 18% 25%, rgba(255,255,255,0.9), rgba(255,255,255,0) 45%),
            radial-gradient(circle at 82% 18%, rgba(255,255,255,0.75), rgba(255,255,255,0) 48%);
          mix-blend-mode:soft-light;
        }
        .iacst-rightGlass2:after{
          content:"";
          position:absolute;
          inset:-2px;
          border-radius:20px;
          pointer-events:none;
          background: linear-gradient(135deg, rgba(255,255,255,0.65), rgba(255,255,255,0.12), rgba(255,255,255,0.55));
          -webkit-mask:
            linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          padding:2px;
          opacity:0.55;
        }
        .iacst-rightBadge{
          width:42px;height:42px;border-radius:14px;
          display:flex;align-items:center;justify-content:center;
          background:rgba(255,255,255,0.65);
          border:1px solid rgba(15,23,42,0.08);
          box-shadow:0 10px 24px rgba(15,23,42,0.06);
          box-sizing:border-box;
          flex:0 0 42px;
        }
        .iacst-rightKicker2{
          font-weight:900;
          letter-spacing:0.08em;
          opacity:0.9;
          font-size:12px;
          color:#0f172a;
          white-space:nowrap;
        }
        .iacst-rightGlass2 svg path{ stroke:#0b1b3a; }
        .iacst-rightTitle2{
          margin-top:14px;
          font-size:18px;
          font-weight:900;
          line-height:1.3;
          color:#0f172a;
          position:relative;
        }
        .iacst-rightItem2{
          padding:12px 14px;
          border-radius:14px;
          background:rgba(255,255,255,0.62);
          border:1px solid rgba(15,23,42,0.08);
          box-shadow:0 12px 26px rgba(15,23,42,0.06);
          color:#0f172a;
          position:relative;
          transition: all 0.3s ease;
        }

        .iacst-rightTip2{
          margin-top:14px;
          padding:12px 14px;
          border-radius:14px;
          background:rgba(255,255,255,0.70);
          border:1px solid rgba(15,23,42,0.10);
          line-height:1.7;
          color:#0f172a;
          position:relative;
        }

        /* ✅ MOBILE FIXES */
        @media (max-width:600px){
          .iacst-wrap{ width:92%; }
          .iacst-card{ padding:18px !important; }
          .iacst-title{ font-size:24px !important; line-height:1.2 !important; }
          .iacst-text{ font-size:16px !important; }
          .iacst-leftColFix, .iacst-rightColFix{
            flex:1 1 100% !important;
            width:100% !important;
            min-width:0 !important;
          }
          .iacst-leftInnerFix{ padding-left:12px !important; }
          .iacst-leftLineFix{ left:11px !important; }
          .iacst-miniopt{ white-space:normal; }
          .iacst-rightHeadFix{ flex-wrap:wrap; }
          .iacst-rightKicker2{ white-space:normal; }
        }
      `}</style>

            <section style={{ width: '100%', padding: '30px 0', background: '#f9fafc' }}>
                <div className="iacst-wrap">
                    <div className="iacst-card" style={{ padding: '26px', position: 'relative', overflow: 'hidden' }}>
                        <div style={{ position: 'absolute', inset: '-140px', background: 'radial-gradient(circle at 25% 30%, rgba(14,165,233,0.12), rgba(14,165,233,0))' }}></div>

                        <div className="iacst-chip" style={{ position: 'relative' }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                <path d="M9 11C10.7 11 12 9.4 12 7.5C12 5.6 10.7 4 9 4C7.3 4 6 5.6 6 7.5C6 9.4 7.3 11 9 11Z" stroke="#1d4ed8" strokeWidth="2" />
                                <path d="M15 20C16.7 20 18 18.4 18 16.5C18 14.6 16.7 13 15 13C13.3 13 12 14.6 12 16.5C12 18.4 13.3 20 15 20Z" stroke="#1d4ed8" strokeWidth="2" />
                            </svg>
                            Step-by-step
                        </div>

                        <h2 className="iacst-title" style={{ fontSize: '34px', marginTop: '12px', position: 'relative' }}>
                            How to Check iACST Result: Step-by-Step Guide?
                        </h2>

                        <p className="iacst-text" style={{ marginTop: '10px', position: 'relative' }}>
                            Here is the complete official process explaining how to check iACST result:
                        </p>

                        <div style={{ display: 'flex', gap: '18px', alignItems: 'stretch', marginTop: '16px' }} className="iacst-stack">

                            <div className="iacst-leftColFix" style={{ flex: '0 0 52%', minWidth: '320px', position: 'relative' }}>
                                <div className="iacst-leftInnerFix" style={{ position: 'relative', paddingLeft: '18px' }}>
                                    <div className="iacst-leftLineFix" style={{ position: 'absolute', left: '17px', top: '10px', bottom: '10px', width: '2px', background: 'linear-gradient(180deg,#1d4ed8,#0ea5e9)', borderRadius: '10px' }}></div>

                                    <div className="iacst-step" style={{ marginBottom: '12px' }}>
                                        <div className="iacst-stepnum">1</div>
                                        <div>
                                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Visit result portal</div>
                                            <div style={{ marginTop: '6px', color: '#334155', lineHeight: '1.6' }}>
                                                Open official website or centre link (SMS/email).
                                            </div>
                                        </div>
                                    </div>

                                    <div className="iacst-step" style={{ marginBottom: '12px' }}>
                                        <div className="iacst-stepnum">2</div>
                                        <div style={{ width: '100%' }}>
                                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Open result section</div>
                                            <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                <span className="iacst-miniopt">
                                                    <span className="iacst-minisvg">
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                            <path d="M10 13C10.7 13.7 11.6 14 12.5 14C13.4 14 14.3 13.7 15 13L18 10C19.3 8.7 19.3 6.7 18 5.4C16.7 4.1 14.7 4.1 13.4 5.4L12.7 6.1" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M14 11C13.3 10.3 12.4 10 11.5 10C10.6 10 9.7 10.3 9 11L6 14C4.7 15.3 4.7 17.3 6 18.6C7.3 19.9 9.3 19.9 10.6 18.6L11.3 17.9" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    iACST Result
                                                </span>
                                                <span className="iacst-miniopt">
                                                    <span className="iacst-minisvg">
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                            <path d="M7 3H15L19 7V21H7V3Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                                            <path d="M15 3V7H19" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    Scholarship Test
                                                </span>
                                                <span className="iacst-miniopt">
                                                    <span className="iacst-minisvg">
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                            <path d="M7 11V8C7 5.2 9.2 3 12 3C14.8 3 17 5.2 17 8V11" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                                            <path d="M6 11H18V21H6V11Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    Result Login
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="iacst-step" style={{ marginBottom: '12px' }}>
                                        <div className="iacst-stepnum">3</div>
                                        <div>
                                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Enter login details</div>
                                            <div style={{ marginTop: '6px', color: '#334155', lineHeight: '1.6' }}>
                                                App/Reg no. + Mobile / DOB.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="iacst-step" style={{ marginBottom: '12px' }}>
                                        <div className="iacst-stepnum">4</div>
                                        <div>
                                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Submit & view</div>
                                            <div style={{ marginTop: '6px', color: '#334155', lineHeight: '1.6' }}>
                                                Score, scholarship %, admission status.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="iacst-step" style={{ marginBottom: '0' }}>
                                        <div className="iacst-stepnum">5</div>
                                        <div>
                                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Save a copy</div>
                                            <div style={{ marginTop: '6px', color: '#334155', lineHeight: '1.6' }}>
                                                Download/screenshot; print if required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="iacst-rightGlass2 iacst-rightColFix" style={{ flex: '0 0 48%', minWidth: '320px' }}>
                                <div style={{ position: 'absolute', width: '360px', height: '360px', borderRadius: '50%', background: 'rgba(14,165,233,0.10)', top: '-180px', left: '-180px' }}></div>
                                <div style={{ position: 'absolute', width: '320px', height: '320px', borderRadius: '50%', background: 'rgba(79,70,229,0.08)', bottom: '-160px', right: '-160px' }}></div>

                                <div style={{ position: 'relative' }}>
                                    <div className="iacst-rightHeadFix" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                        <span className="iacst-rightBadge">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M12 2L20 6V12C20 16.4 16.7 20.2 12 22C7.3 20.2 4 16.4 4 12V6L12 2Z" strokeWidth="2" strokeLinejoin="round" />
                                                <path d="M9 12L11 14L15 10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                        <div className="iacst-rightKicker2">GOOD PRACTICE</div>
                                    </div>

                                    <div className="iacst-rightTitle2">Keep it smooth for admission</div>

                                    <div style={{ marginTop: '12px', display: 'grid', gap: '10px' }}>
                                        <div className="iacst-rightItem2">Save your result safely</div>
                                        <div className="iacst-rightItem2">Use official sources only</div>
                                        <div className="iacst-rightItem2">Keep a printout for verification</div>
                                    </div>

                                    <div className="iacst-rightTip2">
                                        Tip: If it’s slow, try another browser or use mobile data.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
const IacstResultTiming = () => {
    return (
        <>
            <style>{`
        /* Shared utilities (keeps standard consistent, but layouts are unique per section) */
        .iacst-wrap{ width:90%; margin:auto; max-width:1100px; box-sizing:border-box; }
        .iacst-card{ background:#fff; border:1px solid #e7ecf6; border-radius:18px; box-shadow:0 12px 28px rgba(15,23,42,0.06); }
        .iacst-soft{ background:linear-gradient(135deg,#f2f7ff 0%, #ffffff 55%, #f7fbff 100%); }
        .iacst-title{ margin:0; color:#0f172a; font-weight:900; line-height:1.15; }
        .iacst-text{ margin:0; color:#334155; line-height:1.9; font-size:17px; }
        .iacst-chip{
          display:inline-flex; align-items:center; gap:10px;
          padding:10px 14px; border-radius:999px;
          border:1px solid #e7ecf6; background:linear-gradient(135deg,#f5f8ff 0%, #ffffff 70%);
          font-weight:900; color:#0f172a; font-size:14px;
        }
        .iacst-iconbox{
          width:44px; height:44px; flex:0 0 44px;
          min-width:44px; min-height:44px; max-width:44px; max-height:44px;
          border-radius:16px; display:flex; align-items:center; justify-content:center;
          box-sizing:border-box;
        }
        .iacst-grid{ display:grid; gap:16px; }

        /* ✅ GLOBAL MOBILE SAFETY (prevents horizontal scroll) */
        .iacst-wrap *{ max-width:100%; }
        .iacst-timeboard, .iacst-event, .iacst-timeline { box-sizing:border-box; }
        .iacst-event > div{ min-width:0; }
        .iacst-text, .iacst-title{ overflow-wrap:anywhere; word-break:break-word; }

        @media (max-width:900px){
          .iacst-stack{ flex-direction:column !important; }
          .iacst-hide-m{ display:none !important; }
        }

        /* NEW layout: “Timeline board” */
        .iacst-timeboard{
          position:relative;
          overflow:hidden;
          border-radius:22px;
          border:1px solid #e7ecf6;
          background:
            radial-gradient(900px 360px at 12% 18%, rgba(14,165,233,0.14), rgba(14,165,233,0) 60%),
            radial-gradient(820px 340px at 88% 40%, rgba(79,70,229,0.12), rgba(79,70,229,0) 60%),
            linear-gradient(135deg,#ffffff 0%, #f7fbff 55%, #f9fafc 100%);
          box-shadow:0 16px 46px rgba(15,23,42,0.08);
        }
        .iacst-timeboard:before{
          content:"";
          position:absolute; inset:0;
          opacity:0.08;
          background-image:
            radial-gradient(circle at 18% 24%, #1d4ed8 0 2px, transparent 3px),
            radial-gradient(circle at 65% 36%, #0ea5e9 0 2px, transparent 3px),
            radial-gradient(circle at 40% 78%, #4f46e5 0 2px, transparent 3px);
          background-size:56px 56px;
          pointer-events:none;
        }

        .iacst-ribbon{
          position:absolute; top:18px; right:-58px;
          transform:rotate(12deg);
          padding:10px 70px;
          border-radius:999px;
          background:linear-gradient(90deg,#0ea5e9,#1d4ed8,#4f46e5);
          color:#fff;
          font-weight:900;
          letter-spacing:0.06em;
          font-size:12px;
          box-shadow:0 14px 30px rgba(29,78,216,0.22);
          opacity:0.95;
        }

        .iacst-timeline{
          position:relative;
          padding-left:28px;
        }
        .iacst-timeline:before{
          content:"";
          position:absolute;
          left:12px;
          top:6px;
          bottom:6px;
          width:2px;
          border-radius:10px;
          background:linear-gradient(180deg,#0ea5e9,#1d4ed8,#4f46e5);
          opacity:0.85;
        }

        .iacst-event{
          position:relative;
          display:flex;
          gap:12px;
          align-items:flex-start;
          padding:14px 14px 14px 16px;
          border-radius:18px;
          border:1px solid #e7ecf6;
          background:rgba(255,255,255,0.86);
          backdrop-filter:blur(8px);
          box-shadow:0 12px 26px rgba(15,23,42,0.06);
          transition:transform .25s ease, box-shadow .25s ease, border-color .25s ease;
        }
        .iacst-event:hover{
          transform:translateY(-3px);
          box-shadow:0 18px 40px rgba(15,23,42,0.12);
          border-color:#cfe0ff;
        }
        .iacst-dot{
          position:absolute;
          left:-22px;
          top:18px;
          width:14px; height:14px;
          border-radius:50%;
          background:#ffffff;
          border:2px solid #1d4ed8;
          box-shadow:0 0 0 6px rgba(29,78,216,0.10);
        }

        .iacst-mini{
          display:flex;
          gap:12px;
          padding:14px 16px;
          border-radius:18px;
          background:linear-gradient(145deg,#0f172a,#111827);
          color:#fff;
          border:1px solid rgba(255,255,255,0.10);
          box-shadow:0 16px 38px rgba(15,23,42,0.22);
        }
        .iacst-mini p{ margin:0; opacity:0.92; line-height:1.8; }

        /* ✅ MOBILE FIXES */
        @media (max-width:600px){
          .iacst-wrap{ width:92%; }
          .iacst-timeboard{ padding:16px !important; border-radius:18px; }
          .iacst-ribbon{
            right:12px;
            top:12px;
            transform:none;
            padding:8px 12px;
            font-size:11px;
            border-radius:999px;
            max-width:calc(100% - 24px);
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }
          .iacst-headRow{
            flex-direction:column;
            align-items:flex-start !important;
            gap:12px !important;
            padding-right:0 !important;
          }
          .iacst-tipPill{
            width:100%;
            box-sizing:border-box;
          }
          .iacst-title{ font-size:24px !important; line-height:1.2 !important; }
          .iacst-text{ font-size:16px !important; }
          .iacst-leftCol{ min-width:0 !important; width:100% !important; }
          .iacst-timeline{ padding-left:20px; }
          .iacst-timeline:before{ left:8px; }
          .iacst-dot{ left:-16px; top:16px; width:12px; height:12px; }
          .iacst-event{ padding:12px 12px 12px 14px; }
          .iacst-event .evtRow{ flex-wrap:wrap; gap:10px; }
          .iacst-event .evtText{ width:100%; min-width:0; }
          .iacst-iconbox{ width:40px; height:40px; flex:0 0 40px; border-radius:14px; }
          .iacst-iconbox svg{ width:18px; height:18px; }
        }
      `}</style>

            <section style={{ width: '100%', padding: '44px 0', background: '#ffffff' }}>
                <div className="iacst-wrap">

                    <div className="iacst-timeboard" style={{ padding: '22px', position: 'relative' }}>
                        <div className="iacst-ribbon">RESULT WINDOW</div>

                        {/* header */}
                        <div className="iacst-headRow" style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap', paddingRight: '40px' }}>
                            <div>
                                <div className="iacst-chip">
                                    {/* calendar svg */}
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M4 5H20V21H4V5Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M4 9H20" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M8 3V7M16 3V7" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                    Result timing
                                </div>

                                <h2 className="iacst-title" style={{ fontSize: '34px', marginTop: '12px' }}>
                                    When is the iACST Result Declared?
                                </h2>

                                <p className="iacst-text" style={{ marginTop: '10px', maxWidth: '820px' }}>
                                    Since iACST is an Instant Admission Cum Scholarship Test, the result is usually declared immediately or within a very short time after the exam.
                                </p>
                            </div>

                            {/* compact “tip” pill */}
                            <div className="iacst-tipPill" style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '10px 12px', borderRadius: '999px', border: '1px solid #e7ecf6', background: 'rgba(255,255,255,0.82)', backdropFilter: 'blur(8px)' }}>
                                <span className="iacst-iconbox" style={{ background: '#eefdf3' }}>
                                    {/* clock-check svg */}
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#16a34a" strokeWidth="2" />
                                        <path d="M12 7V12L15 14" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.5 12.2L10.3 14L15.5 9" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" />
                                    </svg>
                                </span>
                                <div style={{ fontWeight: 900, color: '#0f172a' }}>Check soon after test</div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '18px', alignItems: 'stretch', marginTop: '16px' }} className="iacst-stack">

                            {/* LEFT: timeline */}
                            <div className="iacst-leftCol" style={{ flex: 1, minWidth: '320px' }}>
                                <div className="iacst-timeline">

                                    {/* Online */}
                                    <div className="iacst-event">
                                        <span className="iacst-dot"></span>
                                        <div className="evtRow" style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', width: '100%', minWidth: 0 }}>
                                            <span className="iacst-iconbox" style={{ background: '#eef5ff' }}>
                                                {/* monitor svg */}
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M4 5H20V15H4V5Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M8 19H16" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M10 15V19" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                            </span>
                                            <div className="evtText" style={{ minWidth: 0 }}>
                                                <div style={{ fontWeight: 900, color: '#0f172a' }}>Online Test</div>
                                                <div style={{ color: '#334155', lineHeight: 1.75 }}>In the case of online tests, students often receive their results on the same day.</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Offline */}
                                    <div className="iacst-event" style={{ marginTop: '14px' }}>
                                        <span className="iacst-dot"></span>
                                        <div className="evtRow" style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', width: '100%', minWidth: 0 }}>
                                            <span className="iacst-iconbox" style={{ background: '#eaf7ff' }}>
                                                {/* building svg */}
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M4 22V4H20V22" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M8 8H10M8 12H10M8 16H10M14 8H16M14 12H16M14 16H16" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                            </span>
                                            <div className="evtText" style={{ minWidth: 0 }}>
                                                <div style={{ fontWeight: 900, color: '#0f172a' }}>Offline Test</div>
                                                <div style={{ color: '#334155', lineHeight: 1.75 }}>For offline tests, the results are generally announced within a few days.</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Notification */}
                                    <div className="iacst-event" style={{ marginTop: '14px' }}>
                                        <span className="iacst-dot"></span>
                                        <div className="evtRow" style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', width: '100%', minWidth: 0 }}>
                                            <span className="iacst-iconbox" style={{ background: '#eefdf3' }}>
                                                {/* sms/mail svg */}
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M4 6H20V18H4V6Z" stroke="#16a34a" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M4 7L12 13L20 7" stroke="#16a34a" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M20 12H22V16" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
                                                </svg>
                                            </span>
                                            <div className="evtText" style={{ minWidth: 0 }}>
                                                <div style={{ fontWeight: 900, color: '#0f172a' }}>Test Notification</div>
                                                <div style={{ color: '#334155', lineHeight: 1.75 }}>Students are informed about their results through SMS on their registered mobile number, email, or directly by their Aakash study centre.</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* note */}
                                <div style={{ marginTop: '16px', padding: '14px 16px', borderRadius: '18px', background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 70%)', border: '1px dashed #cfe0ff' }}>
                                    <p className="iacst-text" style={{ fontSize: '16px' }}>
                                        To instantly check the result after receiving such notifications, it is important for students to know how to check iACST results online. It helps to quickly view complete details and keep a record for admission purposes.
                                    </p>
                                </div>
                            </div>

                            {/* RIGHT: compact “action” panel (kept hidden on mobile as in your code) */}
                            <div className="iacst-hide-m" style={{ flex: '0 0 320px', minWidth: '280px' }}>
                                <div style={{ marginTop: '14px', padding: '14px 16px', borderRadius: '18px', border: '1px solid #e7ecf6', background: '#ffffff', boxShadow: '0 12px 28px rgba(15,23,42,0.06)' }}>
                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                        <span className="iacst-iconbox" style={{ background: '#eef5ff' }}>
                                            {/* link-check svg */}
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M10 13C10.7 13.7 11.6 14 12.5 14C13.4 14 14.3 13.7 15 13L18 10C19.3 8.7 19.3 6.7 18 5.4C16.7 4.1 14.7 4.1 13.4 5.4L12.7 6.1" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M14 11C13.3 10.3 12.4 10 11.5 10C10.6 10 9.7 10.3 9 11L6 14C4.7 15.3 4.7 17.3 6 18.6C7.3 19.9 9.3 19.9 10.6 18.6L11.3 17.9" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M9 12L10.2 13.2L12.8 10.6" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                        <div>
                                            <div style={{ fontWeight: 900, color: '#0f172a' }}>Use official links only</div>
                                            <div style={{ marginTop: '4px', color: '#334155', lineHeight: 1.7 }}>Avoid random websites or agents while checking results.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

const IacstNextSteps = () => {
    return (
        <>
            <style>{`
        .iacst-wrap {
          width: 90%;
          margin: auto;
          max-width: 1100px;
        }

        .iacst-grid3 {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 18px;
          align-items: stretch;
        }

        .iacst-box {
          border-radius: 20px;
          padding: 26px;
          border: 1px solid #e7ecf6;
          background: #fff;
          box-shadow: 0 14px 34px rgba(15, 23, 42, 0.07);
          transition: all 0.25s ease;
          position: relative;
          overflow: hidden;
          min-height: 280px;
          box-sizing: border-box;
        }

        .iacst-box:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 46px rgba(15, 23, 42, 0.14);
          border-color: #cfe0ff;
        }

        .iacst-icon {
          width: 54px;
          height: 54px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;
          background: linear-gradient(135deg, #0ea5e9, #1d4ed8);
        }

        .iacst-title-text {
          margin: 0;
          font-size: 21px;
          font-weight: 900;
          color: #0f172a;
          font-family: inherit;
        }

        .iacst-para {
          margin: 10px 0 0 0;
          color: #334155;
          font-size: 15.5px;
          line-height: 1.8;
        }

        .iacst-list {
          margin-top: 14px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          font-size: 15px;
          color: #0f172a;
          font-weight: 700;
        }

        .iacst-list span {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .iacst-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #1d4ed8;
          flex: 0 0 10px;
        }

        /* ✅ ONLY CARD 3 UPDATED */
        .iacst-card3-glass {
          background:
            radial-gradient(520px 260px at 18% 12%, rgba(14,165,233,0.18), rgba(14,165,233,0) 60%),
            radial-gradient(520px 260px at 86% 32%, rgba(79,70,229,0.16), rgba(79,70,229,0) 60%),
            linear-gradient(145deg, rgba(255,255,255,0.82), rgba(245,250,255,0.65), rgba(255,255,255,0.75)) !important;
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          border: 1px solid rgba(231,236,246,0.95);
          box-shadow: 0 18px 50px rgba(15,23,42,0.10);
          color: #0f172a;
        }

        .iacst-card3-glass svg path {
          stroke: #0b1b3a; /* dark blue */
        }

        .iacst-card3-glass .iacst-icon {
          background: rgba(255,255,255,0.65);
          border: 1px solid rgba(15,23,42,0.08);
          box-shadow: 0 10px 24px rgba(15,23,42,0.06);
        }

        .iacst-card3-glass .iacst-list {
          color: #0f172a;
        }

        .iacst-card3-glass .iacst-dot {
          background: #1d4ed8;
        }

        /* Mobile */
        @media (max-width: 900px) {
          .iacst-grid3 {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

            <section style={{ width: '100%', padding: '60px 0', background: '#f9fafc', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                <div className="iacst-wrap">
                    <div className="iacst-grid3">

                        {/* CARD 1 (UNCHANGED) */}
                        <div className="iacst-box">
                            <div className="iacst-icon">
                                <svg width="26" height="26" fill="none" viewBox="0 0 24 24">
                                    <path d="M12 22s7-5.5 7-12a7 7 0 1 0-14 0c0 6.5 7 12 7 12Z" stroke="white" strokeWidth="2" />
                                    <circle cx="12" cy="10" r="2.5" stroke="white" strokeWidth="2" />
                                </svg>
                            </div>

                            <h3 className="iacst-title-text">Next Steps After Result</h3>
                            <p className="iacst-para">
                                Once your result is visible, take quick action to secure your admission smoothly.
                            </p>

                            <div className="iacst-list">
                                <span><div className="iacst-dot"></div>Visit your Aakash centre</span>
                                <span><div className="iacst-dot"></div>Carry result screenshot</span>
                                <span><div className="iacst-dot"></div>Complete admission process</span>
                            </div>
                        </div>

                        {/* CARD 2 (UNCHANGED) */}
                        <div className="iacst-box">
                            <div className="iacst-icon" style={{ background: 'linear-gradient(135deg,#4f46e5,#1d4ed8)' }}>
                                <svg width="26" height="26" fill="none" viewBox="0 0 24 24">
                                    <path d="M12 9v4" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M12 17h.01" stroke="white" strokeWidth="3" strokeLinecap="round" />
                                    <path d="M10 3h4l8 16H2l8-16Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                </svg>
                            </div>

                            <h3 className="iacst-title-text">Common Problems</h3>
                            <p className="iacst-para">
                                Sometimes students face small issues while checking results online.
                            </p>

                            <div className="iacst-list">
                                <span><div className="iacst-dot"></div>Result page not loading</span>
                                <span><div className="iacst-dot"></div>Forgot application number</span>
                                <span><div className="iacst-dot"></div>Incorrect details shown</span>
                            </div>
                        </div>

                        {/* CARD 3 (ONLY UPDATED) */}
                        <div className="iacst-box iacst-card3-glass">
                            <div className="iacst-icon">
                                <svg width="26" height="26" fill="none" viewBox="0 0 24 24">
                                    <path d="M12 2 20 6v6c0 4.5-3.2 8.2-8 10-4.8-1.8-8-5.5-8-10V6l8-4Z" strokeWidth="2" strokeLinejoin="round" />
                                    <path d="M9 12l2 2 4-4" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </div>

                            <h3 className="iacst-title-text">Important Tips</h3>

                            <p className="iacst-para">
                                Always check results only from official Aakash sources and save them safely.
                            </p>

                            <div className="iacst-list">
                                <span><div className="iacst-dot"></div>Use official portals only</span>
                                <span><div className="iacst-dot"></div>Avoid agents & fake sites</span>
                                <span><div className="iacst-dot"></div>Keep a printed copy ready</span>
                            </div>

                            <div style={{ marginTop: '18px', fontWeight: 900, fontSize: '15px' }}>
                                iACST helps you start strong 🚀
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

const IacstResultDetails = () => {
    return (
        <>
            <style>{`
        .iacst-wrap {
          width: 90%;
          margin: auto;
          max-width: 1100px;
          box-sizing: border-box;
        }

        .iacst-card {
          background: #fff;
          border: 1px solid #e7ecf6;
          border-radius: 18px;
          box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .iacst-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12);
          border-color: #cfe0ff;
        }

        .iacst-iconbox {
          width: 42px;
          height: 42px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #eef5ff;
          flex-shrink: 0;
        }

        .iacst-text {
          margin: 0;
          color: #334155;
          line-height: 1.7;
          font-size: 15px;
        }

        /* ✅ Force 3 cards in one row */
        .iacst-grid3 {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
          align-items: stretch;
        }

        /* Mobile: 1 card per row */
        @media (max-width: 900px) {
          .iacst-grid3 {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

            <section style={{ width: '100%', padding: '44px 0', background: '#f9fafc', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                <div className="iacst-wrap">
                    <div className="iacst-grid3">

                        {/* Card 1 */}
                        <div className="iacst-card" style={{ padding: '22px' }}>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <span className="iacst-iconbox">
                                    {/* percent svg */}
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 5L5 19" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M7.5 8.5C8.3 8.5 9 7.8 9 7C9 6.2 8.3 5.5 7.5 5.5C6.7 5.5 6 6.2 6 7C6 7.8 6.7 8.5 7.5 8.5Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M16.5 18.5C17.3 18.5 18 17.8 18 17C18 16.2 17.3 15.5 16.5 15.5C15.7 15.5 15 16.2 15 17C15 17.8 15.7 18.5 16.5 18.5Z" stroke="#1d4ed8" strokeWidth="2" />
                                    </svg>
                                </span>
                                <h3 style={{ margin: 0, fontWeight: 900, fontSize: '17px', color: '#0f172a' }}>
                                    Scholarship %
                                </h3>
                            </div>

                            <p className="iacst-text" style={{ marginTop: '10px' }}>
                                Your score decides the scholarship applied to tuition fees.
                            </p>
                        </div>

                        {/* Card 2 */}
                        <div className="iacst-card" style={{ padding: '22px' }}>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <span className="iacst-iconbox">
                                    {/* badge svg */}
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L14.5 5.5L18.8 6.2L17 10L18.8 13.8L14.5 14.5L12 18L9.5 14.5L5.2 13.8L7 10L5.2 6.2L9.5 5.5L12 2Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M9 12L11 14L15 10" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <h3 style={{ margin: 0, fontWeight: 900, fontSize: '17px', color: '#0f172a' }}>
                                    Admission Status
                                </h3>
                            </div>

                            <p className="iacst-text" style={{ marginTop: '10px' }}>
                                Shows if you qualify for instant admission (validation may apply).
                            </p>
                        </div>

                        {/* Card 3 */}
                        <div className="iacst-card" style={{ padding: '22px' }}>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <span className="iacst-iconbox">
                                    {/* layers svg */}
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L22 8L12 14L2 8L12 2Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M22 12L12 18L2 12" stroke="#1d4ed8" strokeWidth="2" />
                                    </svg>
                                </span>
                                <h3 style={{ margin: 0, fontWeight: 900, fontSize: '17px', color: '#0f172a' }}>
                                    Batch Allocation
                                </h3>
                            </div>

                            <p className="iacst-text" style={{ marginTop: '10px' }}>
                                Top scorers may get advanced batches; others get regular support.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

const IacstOverview = () => {
    return (
        <>
            <style>{`
        /* Shared utilities */
        .iacst-wrap { width: 90%; margin: auto; max-width: 1100px; box-sizing: border-box; }
        .iacst-card { background: #fff; border: 1px solid #e7ecf6; border-radius: 18px; box-shadow: 0 12px 28px rgba(15,23,42,0.06); }
        .iacst-title { margin: 0; color: #0f172a; font-weight: 900; line-height: 1.15; }
        .iacst-text { margin: 0; color: #334155; line-height: 1.9; font-size: 17px; }
        .iacst-chip {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 10px 14px; border-radius: 999px;
          border: 1px solid #e7ecf6; background: linear-gradient(135deg, #f5f8ff 0%, #ffffff 70%);
          font-weight: 900; color: #0f172a; font-size: 14px;
        }
        .iacst-iconbox {
          width: 42px; height: 42px; flex: 0 0 42px;
          min-width: 42px; min-height: 42px; max-width: 42px; max-height: 42px;
          border-radius: 14px; display: flex; align-items: center; justify-content: center;
          box-sizing: border-box;
        }
        .iacst-grid { display: grid; gap: 16px; }

        /* ✅ GLOBAL MOBILE SAFETY */
        .iacst-card, .iacst-leftPro, .iacst-rightGlass { box-sizing: border-box; }
        .iacst-wrap * { max-width: 100%; }
        .iacst-tile, .iacst-purposeCard { min-width: 0; }
        .iacst-leftTopbar { flex-wrap: wrap; }

        @media (max-width: 900px){
          .iacst-stack { flex-direction: column !important; }
        }

        /* Enhanced left panel */
        .iacst-leftPro {
          position: relative;
          overflow: hidden;
          background:
            radial-gradient(900px 360px at 15% 10%, rgba(14,165,233,0.16), rgba(14,165,233,0) 60%),
            radial-gradient(700px 320px at 85% 35%, rgba(79,70,229,0.12), rgba(79,70,229,0) 60%),
            linear-gradient(135deg, #fbfdff 0%, #ffffff 55%, #f7fbff 100%);
        }
        .iacst-leftPro:before {
          content: "";
          position: absolute; inset: 0;
          opacity: 0.12;
          background-image:
            radial-gradient(circle at 20% 25%, #1d4ed8 0 2px, transparent 3px),
            radial-gradient(circle at 65% 40%, #0ea5e9 0 2px, transparent 3px),
            radial-gradient(circle at 35% 80%, #4f46e5 0 2px, transparent 3px);
          background-size: 46px 46px;
          pointer-events: none;
        }
        .iacst-leftTopbar {
          display: flex; align-items: center; justify-content: space-between; gap: 12px;
          padding: 14px 14px;
          border: 1px solid #e7ecf6;
          border-radius: 16px;
          background: rgba(255,255,255,0.75);
          backdrop-filter: blur(8px);
        }
        .iacst-pill {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 8px 12px;
          border-radius: 999px;
          border: 1px solid #d9e6ff;
          background: #eef5ff;
          font-weight: 900;
          color: #1d4ed8;
          font-size: 12px;
          white-space: nowrap;
        }
        .iacst-tile {
          display: flex; gap: 12px; align-items: flex-start;
          padding: 14px 14px;
          border-radius: 16px;
          border: 1px solid #e7ecf6;
          background: rgba(255,255,255,0.86);
          backdrop-filter: blur(8px);
          box-shadow: 0 10px 22px rgba(15,23,42,0.06);
          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
        }
        .iacst-tile:hover {
          transform: translateY(-3px);
          box-shadow: 0 18px 40px rgba(15,23,42,0.12);
          border-color: #cfe0ff;
        }
        .iacst-icGlow {
          width: 44px; height: 44px; flex: 0 0 44px;
          border-radius: 16px;
          display: flex; align-items: center; justify-content: center;
          background: linear-gradient(135deg, #0ea5e9, #1d4ed8);
          box-shadow: 0 14px 26px rgba(29,78,216,0.18);
        }
        .iacst-leftTitle {
          font-size: 28px;
          margin-top: 14px;
        }

        /* RIGHT: Glass finish */
        .iacst-rightGlass {
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          padding: 18px;
          border: 1px solid rgba(231,236,246,0.95);
          background:
            radial-gradient(520px 260px at 15% 10%, rgba(14,165,233,0.18), rgba(14,165,233,0) 60%),
            radial-gradient(520px 260px at 85% 30%, rgba(79,70,229,0.16), rgba(79,70,229,0) 60%),
            linear-gradient(145deg, rgba(255,255,255,0.74) 0%, rgba(245,250,255,0.62) 55%, rgba(255,255,255,0.70) 100%);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          box-shadow: 0 18px 50px rgba(15,23,42,0.10);
          color: #0f172a;
        }
        .iacst-rightGlass:before {
          content: "";
          position: absolute; inset: 0;
          pointer-events: none;
          opacity: 0.55;
          background:
            radial-gradient(circle at 20% 30%, rgba(255,255,255,0.9), rgba(255,255,255,0) 45%),
            radial-gradient(circle at 80% 20%, rgba(255,255,255,0.75), rgba(255,255,255,0) 48%);
          mix-blend-mode: soft-light;
        }
        .iacst-rightGlass:after {
          content: "";
          position: absolute;
          inset: -2px;
          border-radius: 18px;
          pointer-events: none;
          background: linear-gradient(135deg, rgba(255,255,255,0.65), rgba(255,255,255,0.15), rgba(255,255,255,0.55));
          -webkit-mask:
            linear-gradient(#000 0 0) content-box,
            linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          padding: 2px;
          opacity: 0.55;
        }

        .iacst-rightKicker {
          font-weight: 900;
          letter-spacing: 0.08em;
          opacity: 0.9;
          font-size: 12px;
          color: #0f172a;
        }

        .iacst-rightHeaderIcon {
          background: rgba(255,255,255,0.58);
          border: 1px solid rgba(15,23,42,0.08);
          box-shadow: 0 10px 24px rgba(15,23,42,0.06);
        }

        .iacst-purposeCard {
          display: flex; gap: 12px; align-items: flex-start;
          padding: 12px 14px;
          border-radius: 14px;
          background: rgba(255,255,255,0.62);
          border: 1px solid rgba(15,23,42,0.08);
          box-shadow: 0 12px 26px rgba(15,23,42,0.06);
          color: #0f172a;
        }

        .iacst-purposeIcon {
          background: rgba(255,255,255,0.70);
          border: 1px solid rgba(15,23,42,0.08);
          border-radius: 14px;
          box-shadow: 0 10px 22px rgba(15,23,42,0.06);
        }

        /* Make RIGHT icons dark */
        .iacst-rightGlass svg path {
          stroke: #0b1b3a;
        }

        /* ✅ MOBILE FIXES */
        @media (max-width: 600px) {
          .iacst-wrap { width: 92%; }
          .iacst-leftPro, .iacst-rightGlass {
            min-width: 0 !important;
            width: 100% !important;
          }
          .iacst-leftTopbar {
            justify-content: flex-start;
            gap: 10px;
          }
          .iacst-pill { white-space: normal; }
          .iacst-grid {
            grid-template-columns: 1fr !important;
          }
          .iacst-leftTitle {
            font-size: 22px !important;
            line-height: 1.25 !important;
          }
          .iacst-text { font-size: 16px !important; }
          .iacst-purposeCard div,
          .iacst-tile div {
            overflow-wrap: anywhere;
            word-break: break-word;
          }
        }
      `}</style>

            <section style={{ width: '100%', padding: '44px 0', background: '#ffffff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                <div className="iacst-wrap">
                    <div className="iacst-card" style={{ padding: '26px' }}>
                        <div style={{ display: 'flex', gap: '18px', alignItems: 'stretch' }} className="iacst-stack">

                            {/* LEFT: COURSE LIST */}
                            <div className="iacst-leftPro" style={{ flex: 1, minWidth: '320px', padding: '18px', borderRadius: '16px', border: '1px solid #e7ecf6' }}>
                                <div style={{ position: 'relative' }}>
                                    {/* top bar */}
                                    <div className="iacst-leftTopbar">
                                        <div className="iacst-chip">
                                            {/* info svg */}
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#1d4ed8" strokeWidth="2" />
                                                <path d="M12 10V17" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M12 7H12.01" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
                                            </svg>
                                            Overview
                                        </div>

                                        <div className="iacst-pill">
                                            {/* sparkle svg */}
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M12 2L13.6 8.4L20 10L13.6 11.6L12 18L10.4 11.6L4 10L10.4 8.4L12 2Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                            </svg>
                                            Entrance + Scholarship
                                        </div>
                                    </div>

                                    <h2 className="iacst-title iacst-leftTitle">
                                        What is iACST (Instant Admission Cum Scholarship Test)?
                                    </h2>

                                    <p className="iacst-text" style={{ marginTop: '10px' }}>
                                        iACST stands for Instant Admission Cum Scholarship Test. It is an entrance and scholarship test conducted by Aakash Educational Services Limited (AESL) for students who want to join:
                                    </p>

                                    {/* cards grid */}
                                    <div className="iacst-grid" style={{ gridTemplateColumns: 'repeat(2, minmax(0,1fr))', marginTop: '14px', position: 'relative' }}>
                                        {/* item */}
                                        <div className="iacst-tile">
                                            <span className="iacst-icGlow">
                                                {/* medical cross svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M10 3H14V10H21V14H14V21H10V14H3V10H10V3Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div style={{ fontWeight: 900, color: '#0f172a', lineHeight: 1.35 }}>NEET (Medical) coaching</div>
                                        </div>

                                        <div className="iacst-tile">
                                            <span className="iacst-icGlow">
                                                {/* gear svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M12 15.5C13.9 15.5 15.5 13.9 15.5 12C15.5 10.1 13.9 8.5 12 8.5C10.1 8.5 8.5 10.1 8.5 12C8.5 13.9 10.1 15.5 12 15.5Z" stroke="white" strokeWidth="2" />
                                                    <path d="M19.4 15L21 12L19.4 9L16.8 9.4L15.6 7L12 6L8.4 7L7.2 9.4L4.6 9L3 12L4.6 15L7.2 14.6L8.4 17L12 18L15.6 17L16.8 14.6L19.4 15Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div style={{ fontWeight: 900, color: '#0f172a', lineHeight: 1.35 }}>JEE (Engineering) coaching</div>
                                        </div>

                                        <div className="iacst-tile">
                                            <span className="iacst-icGlow">
                                                {/* book svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M6 3H18V21H6C4.9 21 4 20.1 4 19V5C4 3.9 4.9 3 6 3Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M8 7H16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M8 11H16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                            </span>
                                            <div style={{ fontWeight: 900, color: '#0f172a', lineHeight: 1.35 }}>Foundation courses (Class 8, 9, 10)</div>
                                        </div>

                                        <div className="iacst-tile">
                                            <span className="iacst-icGlow">
                                                {/* cap svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M12 3L2 9L12 15L22 9L12 3Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M6 12V17C6 19 9 21 12 21C15 21 18 19 18 17V12" stroke="white" strokeWidth="2" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div style={{ fontWeight: 900, color: '#0f172a', lineHeight: 1.35 }}>Senior secondary courses (Class 11, 12)</div>
                                        </div>

                                        <div className="iacst-tile" style={{ gridColumn: '1/-1' }}>
                                            <span className="iacst-icGlow">
                                                {/* refresh svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M21 12A9 9 0 1 1 6.5 5.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M6 3V7H10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div style={{ fontWeight: 900, color: '#0f172a', lineHeight: 1.35 }}>Droppers / Repeaters</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT: PURPOSES */}
                            <div className="iacst-rightGlass" style={{ flex: 1, minWidth: '320px' }}>
                                <div style={{ position: 'relative' }}>
                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                        <span className="iacst-iconbox iacst-rightHeaderIcon">
                                            {/* target svg */}
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" strokeWidth="2" />
                                                <path d="M12 16C14.2 16 16 14.2 16 12C16 9.8 14.2 8 12 8C9.8 8 8 9.8 8 12C8 14.2 9.8 16 12 16Z" strokeWidth="2" />
                                                <path d="M12 2V6" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </span>
                                        <div className="iacst-rightKicker">MAIN PURPOSES</div>
                                    </div>

                                    <div style={{ marginTop: '14px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                        <div className="iacst-purposeCard">
                                            <span className="iacst-iconbox iacst-purposeIcon">
                                                {/* bolt svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M13 2L3 14H11L9 22L21 10H13V2Z" strokeWidth="2" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div>To provide instant admission into Aakash courses</div>
                                        </div>

                                        <div className="iacst-purposeCard">
                                            <span className="iacst-iconbox iacst-purposeIcon">
                                                {/* award svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M12 15C15.3 15 18 12.3 18 9C18 5.7 15.3 3 12 3C8.7 3 6 5.7 6 9C6 12.3 8.7 15 12 15Z" strokeWidth="2" />
                                                    <path d="M9 14L8 21L12 19L16 21L15 14" strokeWidth="2" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div>To offer scholarships based on merit</div>
                                        </div>

                                        <div className="iacst-purposeCard">
                                            <span className="iacst-iconbox iacst-purposeIcon">
                                                {/* chart svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M4 19V5" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M4 19H20" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M7 15V12" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M12 15V9" strokeWidth="2" strokeLinecap="round" />
                                                    <path d="M17 15V6" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                            </span>
                                            <div>To assess the academic level of the student</div>
                                        </div>

                                        <div className="iacst-purposeCard">
                                            <span className="iacst-iconbox iacst-purposeIcon">
                                                {/* layers svg */}
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                                    <path d="M12 2L22 8L12 14L2 8L12 2Z" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M22 12L12 18L2 12" strokeWidth="2" strokeLinejoin="round" />
                                                    <path d="M22 16L12 22L2 16" strokeWidth="2" strokeLinejoin="round" />
                                                </svg>
                                            </span>
                                            <div>To place students in the right batch according to their preparation level</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
const IacstWhatResultDetails = () => {
    return (
        <>
            <style>{`
        /* Shared utilities */
        .iacst-wrap { width: 90%; margin: auto; max-width: 1100px; box-sizing: border-box; }
        .iacst-card { background: #fff; border: 1px solid #e7ecf6; border-radius: 18px; box-shadow: 0 12px 28px rgba(15,23,42,0.06); }
        .iacst-title { margin: 0; color: #0f172a; font-weight: 900; line-height: 1.15; }
        .iacst-text { margin: 0; color: #334155; line-height: 1.9; font-size: 17px; }

        .iacst-chip {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 10px 14px; border-radius: 999px;
          border: 1px solid #e7ecf6; background: linear-gradient(135deg, #f5f8ff 0%, #ffffff 70%);
          font-weight: 900; color: #0f172a; font-size: 14px;
          max-width: 100%;
        }

        /* ✅ Prevent mobile overflow / weird breaks */
        .iacst-wrap * { box-sizing: border-box; max-width: 100%; }
        .iacst-title, .iacst-text { overflow-wrap: anywhere; word-break: break-word; }

        .iacst-hover {
          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
        }
        .iacst-hover:hover {
          transform: translateY(-3px);
          box-shadow: 0 18px 44px rgba(15,23,42,0.12);
          border-color: #cfe0ff;
        }

        /* Result field tiles */
        .iacst-field {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 14px;
          border-radius: 16px;
          border: 1px solid #e7ecf6;
          background: linear-gradient(135deg, #fbfcff 0%, #ffffff 70%);
          box-shadow: 0 10px 22px rgba(15,23,42,0.04);
          box-sizing: border-box;
          min-width: 0;
        }
        .iacst-fieldIcon {
          width: 44px; height: 44px; flex: 0 0 44px;
          border-radius: 16px;
          display: flex; align-items: center; justify-content: center;
          background: linear-gradient(135deg, #eaf2ff 0%, #f3fbff 100%);
          border: 1px solid #dbe9ff;
          box-sizing: border-box;
        }
        .iacst-fieldLabel {
          font-weight: 900;
          color: #0f172a;
          line-height: 1.2;
        }
        .iacst-fieldSub {
          margin-top: 2px;
          font-size: 13px;
          color: #64748b;
          font-weight: 700;
          line-height: 1.3;
        }

        @media (max-width: 900px) {
          .iacst-stack { flex-direction: column !important; }
        }

        /* ✅ Mobile fixes */
        @media (max-width: 640px) {
          .iacst-card { padding: 18px !important; }
          .iacst-title { font-size: 24px !important; line-height: 1.2 !important; }
          .iacst-text { font-size: 16px !important; }
        }

        /* ✅ Grid responsiveness */
        .iacst-fieldsGrid {
          position: relative;
          margin-top: 18px;
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 12px;
        }
        @media (max-width: 980px) {
          .iacst-fieldsGrid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .iacst-span2 { grid-column: 1 / -1 !important; }
        }
        @media (max-width: 640px) {
          .iacst-fieldsGrid { grid-template-columns: 1fr; }
          .iacst-span2 { grid-column: auto !important; }
        }
      `}</style>

            <section style={{ width: '100%', padding: '44px 0', background: '#ffffff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                <div className="iacst-wrap">
                    <div className="iacst-card" style={{ padding: '26px', position: 'relative', overflow: 'hidden' }}>

                        {/* subtle top glow */}
                        <div style={{ position: 'absolute', inset: '-140px', background: 'radial-gradient(circle at 25% 20%, rgba(14,165,233,0.12), rgba(14,165,233,0))', pointerEvents: 'none' }}></div>

                        <div style={{ position: 'relative', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '18px', flexWrap: 'wrap' }}>
                            <div>
                                <div className="iacst-chip">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M9 6H20" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M9 12H20" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M9 18H20" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4 6H4.01" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
                                        <path d="M4 12H4.01" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
                                        <path d="M4 18H4.01" stroke="#1d4ed8" strokeWidth="3" strokeLinecap="round" />
                                    </svg>
                                    Result contents
                                </div>

                                <h2 className="iacst-title" style={{ fontSize: '32px', marginTop: '12px' }}>
                                    What Details Are Mentioned in the iACST Result?
                                </h2>

                                <p className="iacst-text" style={{ marginTop: '10px' }}>
                                    Your result typically shows these key fields:
                                </p>
                            </div>
                        </div>

                        {/* tiles grid */}
                        <div className="iacst-fieldsGrid">
                            {/* 1 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M12 12C14.2 12 16 10.2 16 8C16 5.8 14.2 4 12 4C9.8 4 8 5.8 8 8C8 10.2 9.8 12 12 12Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M4 20C5.6 17.6 8.6 16 12 16C15.4 16 18.4 17.6 20 20" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Student’s name</div>
                                    <div className="iacst-fieldSub">As registered</div>
                                </div>
                            </div>

                            {/* 2 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M4 7H20V17H4V7Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M7 10H13" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M7 14H10" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16.5 14C17.3 14 18 13.3 18 12.5C18 11.7 17.3 11 16.5 11C15.7 11 15 11.7 15 12.5C15 13.3 15.7 14 16.5 14Z" stroke="#1d4ed8" strokeWidth="2" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Application / roll no.</div>
                                    <div className="iacst-fieldSub">Unique ID</div>
                                </div>
                            </div>

                            {/* 3 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M12 3L2 9L12 15L22 9L12 3Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M6 12V17C6 19 9 21 12 21C15 21 18 19 18 17V12" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Class & course</div>
                                    <div className="iacst-fieldSub">Selected program</div>
                                </div>
                            </div>

                            {/* 4 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M4 19V5" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4 19H20" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M7 15V12" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M12 15V9" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M17 15V6" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Marks / performance</div>
                                    <div className="iacst-fieldSub">Score summary</div>
                                </div>
                            </div>

                            {/* 5 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M19 5L5 19" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M7.5 8.5C8.3 8.5 9 7.8 9 7C9 6.2 8.3 5.5 7.5 5.5C6.7 5.5 6 6.2 6 7C6 7.8 6.7 8.5 7.5 8.5Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M16.5 18.5C17.3 18.5 18 17.8 18 17C18 16.2 17.3 15.5 16.5 15.5C15.7 15.5 15 16.2 15 17C15 17.8 15.7 18.5 16.5 18.5Z" stroke="#1d4ed8" strokeWidth="2" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Scholarship %</div>
                                    <div className="iacst-fieldSub">If applicable</div>
                                </div>
                            </div>

                            {/* 6 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M20 6L9 17L4 12" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Admission status</div>
                                    <div className="iacst-fieldSub">Eligible / next steps</div>
                                </div>
                            </div>

                            {/* 7 */}
                            <div className="iacst-field iacst-hover">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#1d4ed8" strokeWidth="2" />
                                        <path d="M12 7V12L15 14" stroke="#1d4ed8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Validity</div>
                                    <div className="iacst-fieldSub">Result window</div>
                                </div>
                            </div>

                            {/* 8 */}
                            <div className="iacst-field iacst-hover iacst-span2">
                                <div className="iacst-fieldIcon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                                        <path d="M12 2L22 8L12 14L2 8L12 2Z" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M22 12L12 18L2 12" stroke="#1d4ed8" strokeWidth="2" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div className="iacst-fieldLabel">Batch / course suggestion</div>
                                    <div className="iacst-fieldSub">Shown in some cases</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

const IacstResult = () => {
    const examType = useSelector((state) => state.examType.examType)

    const faqQuestions = FAQConfig.iACST_Result.map((item, index) => ({
        targetId: (index + 1).toString(),
        heading: item.question,
        subheading: item.answer,
        bulletpoints: []
    }))
    if (examType !== 'iACST') {
        return <PageNotFound />
    }
    return (
        <div className={styles.iacstMain}>
            <Helmet>
                <title>How to Check iACST Result: Complete Guide for Aakash Students</title>
                <meta name="description" content="Learn how to check iACST results for Aakash’s Instant Admission Cum Scholarship Test. Find here the result details, next steps, and FAQs explained simply." />
                <meta name="keywords" content="iACST Result" />
                <link rel="canonical" href="https://iacst.aakash.ac.in/iacst-result" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://new-iacst.aakash.ac.in/iacst-result" />
                <meta property="og:title" content="iACST Result – Instant Admission Cum Scholarship Test | Aakash" />
                <meta property="og:description" content="Check your Aakash iACST (Instant Admission Cum Scholarship Test) result instantly. View your score, scholarship percentage, and find out how much fee concession you've earned on NEET, JEE & Foundation courses." />
                <meta property="og:image" content="https://iacst.aakash.ac.in/static/media/iACST_Hero_final.5d3da4d6.png" />
                <meta property="og:image:alt" content="Aakash iACST – Instant Admission Cum Scholarship Test Result" />
                <meta property="og:site_name" content="Aakash iACST" />
                <meta property="og:locale" content="en_IN" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://iacst.aakash.ac.in/iacst-result" />
                <meta name="twitter:title" content="iACST Result – Instant Admission Cum Scholarship Test | Aakash" />
                <meta name="twitter:description" content="Check your Aakash iACST (Instant Admission Cum Scholarship Test) result instantly. View your score, scholarship percentage, and find out how much fee concession you've earned on NEET, JEE & Foundation courses." />
                <meta name="twitter:image" content="https://iacst.aakash.ac.in/static/media/iACST_Hero_final.5d3da4d6.png" />
                <meta name="twitter:image:alt" content="Aakash iACST – Instant Admission Cum Scholarship Test Result" />
                <meta name="twitter:site" content="@AESL_Official" />
            </Helmet>

            {/* HEADER */}
            <div style={{ width: '100%', backgroundColor: '#ffffff', padding: '10px 20px', boxSizing: 'border-box', borderBottom: '1px solid #e0e0e0' }}>
                <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src="https://uat-iacst.aakash.ac.in/static/media/aakash-logo.27a40e9d.png" alt="Aakash Logo" style={{ height: '55px', width: 'auto' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ backgroundColor: '#42a5f5', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <img src="https://uat-iacst.aakash.ac.in/static/media/call-icon-iacst.cecbde51.svg" alt="calling-icon" style={{ width: '20px', height: '20px' }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: '14px', color: '#444' }}>Call us</span>
                            <a href="tel:7303529494" style={{ fontSize: '18px', fontWeight: 'bold', color: '#2196f3', textDecoration: 'none', marginTop: '2px' }}>7303529494</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* HERO SECTION */}
            <IacstResultHero />
            {/* SECTION 2: PURPOSE */}
            <IacstOverview />

            {/* SECTION 3: WHY IMPORTANT */}
            <IacstResultImportance />
            {/* SECTION 4: TIMING */}
            <IacstResultTiming />
            {/* SECTION 5: STEP-BY-STEP */}
            <IacstStepGuide />
            {/* SECTION 6: WHAT DETAILS */}
            <IacstWhatResultDetails />
            {/* SECTION 7: THREE CARD GRID */}
            <IacstResultDetails />
            {/* SECTION 8: IMPORTANT TIPS (Grid Layout Continued) */}
            <IacstNextSteps />
            {/* FAQ SECTION */}
            < section style={{ width: '100%', padding: '22px 0', backgroundColor: '#ffffff' }}>
                <Faqaccordion
                    questions={faqQuestions} />
            </section >
            {/* FOOTER */}
            < footer style={{ backgroundColor: '#0f0f0f', padding: '28px', textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: '14px', color: 'white' }}>
                    © 2026 All right reserved by Aakash Educational Services Limited | Email Us:
                    <a href="mailto:acstsupport@aesl.in" style={{ textDecoration: 'none', color: 'white', marginLeft: '5px' }}>acstsupport@aesl.in</a>
                </p>
            </footer >
        </div >
    );
};

export default IacstResult;



